import type {
  ItemListFiltersStateKey,
} from '@autobid/ui/composables/carsList/useFilter'
import type { Ref } from 'vue'
import { LIST_OF_SUPPORTED_CARS_LIST_FILTERS } from '@autobid/ui/composables/car/data/useAuctionCars'
import { LIST_OF_SUPPORTED_SEARCH_LIST_FILTERS } from '@autobid/ui/composables/car/data/useSearchCars'
import { useCarPageInfo } from '@autobid/ui/composables/car/useCarPageInfo'
import {
  useCarsListUrlFilter,
} from '@autobid/ui/composables/carsList/useFilter'
import { computed } from 'vue'

export function useCarsListFilters() {
  const { pageType } = useCarPageInfo()
  const { filters } = useCarsListUrlFilter()

  const filtersTabActive = useState(
    'filterTabActive',
    () => false,
  ) as Ref<boolean>

  const listOfFields
    = pageType.value === 'carList'
      ? LIST_OF_SUPPORTED_CARS_LIST_FILTERS
      : LIST_OF_SUPPORTED_SEARCH_LIST_FILTERS

  const NO_CHIPS_FILTERS: ItemListFiltersStateKey[] = [
    'currentPage',
    'pageType',
    'sortingType',
  ]

  const filtersQty = computed(() => {
    return Object.entries(filters).reduce((acc, el) => {
      const [key, value] = el

      if (NO_CHIPS_FILTERS.includes(key as ItemListFiltersStateKey))
        return acc

      if (!listOfFields.includes(key as ItemListFiltersStateKey))
        return acc

      if (
        String(value.value) === 'undefined'
        || (Array.isArray(value.value) && !value.value.length)
      ) {
        return acc
      }

      return acc + 1
    }, 0)
  })

  return { filtersTabActive, filtersQty }
}
